import { render } from "./Event_Image_Placeholder.vue?vue&type=template&id=64ebe646&scoped=true"
import script from "./Event_Image_Placeholder.vue?vue&type=script&lang=js"
export * from "./Event_Image_Placeholder.vue?vue&type=script&lang=js"

import "./Event_Image_Placeholder.vue?vue&type=style&index=0&id=64ebe646&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64ebe646"]])

export default __exports__